<script setup lang="ts">
  import { computed } from 'vue'
  import { useDeckStore } from '@/store'
  import { pickEventName } from '@/lib/events'

  const props = defineProps<{
    eventIds: string[]
    langs: (string | undefined)[]
  }>()

  const { getEventById } = useDeckStore()

  const events = computed(() =>
    props.eventIds.map(id => ({
      id,
      name: pickEventName(getEventById(id), props.langs)
    }))
  )

  const title = computed(() =>
    events.value
      .map(ev => (ev.name ? `${ev.name} (#${ev.id})` : `#${ev.id}`))
      .join(' · ')
  )
</script>

<template>
  <span :title="title">
    <template
      v-for="(ev, i) in events"
      :key="ev.id"
    >
      <span
        v-if="i"
        class="opacity-50"
      >
        ·
      </span>
      <span v-if="ev.name">{{ ev.name }}</span>
      <span
        v-else
        class="skeleton inline-block h-3 w-24 align-middle"
      ></span>
    </template>
  </span>
</template>
